<script lang="ts">
  import type { PopupSettings } from '@skeletonlabs/skeleton'

  import LabelStudioIcon from '@components/LabelStudioIcon.svelte'
  import Link from '@components/Link.svelte'

  export interface SubMenuProps {
    title: string
    path: string
    items: { path: string; label: string; root?: boolean; newTab?: boolean }[]
  }

  const { title, path, items }: SubMenuProps = $props()

  const popupSettings: PopupSettings = $derived({
    event: 'click',
    target: `submenu-${title}`,
    placement: 'bottom',
  })
</script>

<Link {popupSettings} {path}>
  {title}
</Link>

<div class="popup z-[1000]" data-popup={`submenu-${title}`}>
  <nav class="list-nav">
    <ul>
      {#each items as item (item.path)}
        <li>
          <Link
            path={item.root ? item.path : `${path}${item.path}`}
            hideActive
            newTab={item.newTab}
          >
            {#if item.label === 'Label Studio'}
              <span class="flex items-center justify-center gap-2">
                {item.label}
                <LabelStudioIcon />
              </span>
            {:else}
              {item.label}
            {/if}
          </Link>
        </li>
      {/each}
    </ul>
  </nav>
</div>

<style lang="postcss">
  .popup {
    @apply rounded-lg bg-surface-50 p-2 shadow-lg;
  }

  :global(.dark) .popup {
    @apply bg-surface-800;
  }

  .popup :global(li a),
  .popup :global(li button) {
    @apply text-surface-900;
  }

  :global(.dark) .popup :global(li a),
  :global(.dark) .popup :global(li button) {
    @apply text-surface-50;
  }

  .popup :global(li a:hover),
  .popup :global(li button:hover) {
    color: var(--color-theme-1);
  }
</style>
